export default __webpack_public_path__ + "static/media/ic_kaspersky.d8eaa4eb.jpg";